<div class="bdo-container--single">
  <p class="re-mb-default" [innerHTML]="(!showRegistrationDataForm ?
    'register.description.text' :
    'register.description.activate') | translate: {contactLink: reBaseData.hrefContact }">

  </p>
</div>

@if (activationState !== ActivationStateEnum.NONE) {
  <div class="bdo-container--single">
    @switch (activationState) {
      @case (ActivationStateEnum.ACTIVATION_FAILED) {
        <bdo-info-box>
          {{ 'register.error.expiredLink' | translate }}
        </bdo-info-box>
      }
      @case (ActivationStateEnum.CODE_INVALID) {
        <bdo-info-box>
          {{ 'register.error.invalidLink' | translate }}
        </bdo-info-box>
      }
      @default {
        <bdo-info-box>
          {{ 'general.error.error' | translate }}
        </bdo-info-box>
      }
    }
  </div>
}

@if (registerError !== RegisterErrorEnum.NONE) {
  <div class="bdo-container--single">
    @switch (registerError) {
      @case (RegisterErrorEnum.WRONG_COMBINATION) {
        <bdo-info-box>
          {{ 'register.error.combinationNotFoundWithCode' | translate }}
        </bdo-info-box>
      }
      @case (RegisterErrorEnum.ACCOUNT_EXISTS) {
        <bdo-info-box>
          {{ 'register.error.alreadyInUse' | translate }}
        </bdo-info-box>
      }
      @case (RegisterErrorEnum.USERNAME_ASSIGNED) {
        <bdo-info-box>
          {{ 'register.error.usernameAlreadyInUse' | translate }}
        </bdo-info-box>
      }
      @case (RegisterErrorEnum.MALFORMED_MAILADDRESS) {
        <bdo-info-box>
          {{ 'register.error.requestCorrectedEmail' | translate }}
        </bdo-info-box>
      }
      @case (RegisterErrorEnum.MALFORMED_PASSWORD) {
        <bdo-info-box>
          {{ 'register.error.requestNewPassword' | translate }}
        </bdo-info-box>
      }
      @case (RegisterErrorEnum.COMPROMISED_PASSWORD) {
        <bdo-info-box>
          {{ 'register.error.compromisedPassword' | translate }}
        </bdo-info-box>
      }
      @case (RegisterErrorEnum.MALFORMED_USERNAME) {
        <bdo-info-box>
          {{ 'register.error.requestUsername' | translate }}
        </bdo-info-box>
      }
      @case (RegisterErrorEnum.MAIL_ERROR) {
        <bdo-info-box>
          {{ 'register.error.emailFailed' | translate }}
        </bdo-info-box>
      }
      @case (RegisterErrorEnum.NOT_INTENDED_FOR_OS) {
        <bdo-info-box>
    <span [innerHTML]="'register.error.unuseableAccount' | translate:
           { contactLink: reBaseData.hrefContact, ariaLabel: 'register.aria.customerService' | translate }"
          ></span>
        </bdo-info-box>
      }
      @default {
        <bdo-info-box>
          {{ 'general.error.error' | translate }}
        </bdo-info-box>
      }
    }
  </div>
}

<div class="bdo-container--single">
  <form #registerForm="ngForm" class="bdo-form-container" (ngSubmit)="register(registerForm)"  autocomplete="off" [attr.aria-label]="'aria.form.registration' | translate">
    @if (sendingData) {
      <bdo-loading></bdo-loading>
    }

    <fieldset [class.hidden]="showRegistrationDataForm" name="register-form" [attr.aria-label]="'aria.fieldset.loginCredentials' | translate">
      <div class="bdo-form-item-container">
        <bdo-single-line-input
          [attr.data-qa]="'accountIdInput'"
          #accountIdInput
          [inputName]="'accountId'"
          [placeholder]="'general.customerData.account' | translate"
          [labelText]="'general.customerData.account' | translate"
          [inputValue]="accountId"
          (inputValueChanged)="accountId=$event; onFocus()"
          (inputFocused)="onFocus()"
          [required]="true"
          [forceValidate]="validateAll"
          [validationIconHidden]="validationIconHidden"
          [errors]="[{text: ('register.account.accountIdRequired' | translate), name:'required'},
                    { condition: !containsOnlyDigits(registerForm.value?.accountId), text: ('register.account.accountIdOnlyDigits' | translate), name: 'digits'},
                    { condition: !isValidAccountId(registerForm.value?.accountId), text: ('register.account.accountIdInvalid' | translate), name: 'accountId'}]"
        ></bdo-single-line-input>

        <div class="re-absolute re-right-0 re-top-0">
          <bdo-inline-tooltip>
            <span [innerHTML]="'register.account.accountIdHint' | translate"></span>
          </bdo-inline-tooltip>
        </div>
      </div>

      <div class="bdo-form-item-container">
        <bdo-single-line-input
          #registercodeInput
          [inputName]="'registercode'"
          [placeholder]="'register.code.label' | translate"
          [labelText]="'register.code.label' | translate"
          [inputValue]="meterNumberOrRegisterCode"
          (inputValueChanged)="meterNumberOrRegisterCode=$event; onFocus()"
          (inputFocused)="onFocus()"
          [required]="true"
          [forceValidate]="validateAll"
          [validationIconHidden]="validationIconHidden"
          [errors]="[{text: ('register.code.required' | translate), name:'required'},
                    { condition: !isValidRegistercode(registerForm.value?.registercode), text: ('register.code.invalid' | translate), name: 'registercode'}]"
        ></bdo-single-line-input>

        <div class="re-absolute re-right-0 re-top-0">
          <bdo-inline-tooltip>
            <div [innerHTML]="'register.code.hint' | translate: {contactLink: reBaseData.hrefContact }"></div>
          </bdo-inline-tooltip>
        </div>
      </div>

      <div>
        <button class="bdo-button-primary bdo-button--text re-mb-30" type="submit">
          {{ 'general.action.continue' | translate }}
        </button>
        <div>
          <a class="bdo-nolink bold" [routerLink]="['/login']" data-qa="cancel">
           {{ 'general.action.cancel' | translate }}
          </a>
        </div>

      </div>

    </fieldset>

    @if (showRegistrationDataForm) {
      <fieldset name="user-registration-details" [attr.aria-label]="'aria.fieldset.personalDataDetails' | translate">
        <div class="bdo-form-item-container">
          <bdo-single-line-input
            #mailInput
            [inputName]="'mail'"
            [inputValue]="mail"
            [inputType]="'email'"
            [placeholder]="'address.email.title' | translate"
            [labelText]="'address.email.title' | translate"
            (inputValueChanged)="mail=$event; onFocus()"
            (inputFocused)="onFocus()"
            [required]="true"
            [forceValidate]="validateAll"
            [validationIconHidden]="validationIconHidden"
          [errors]="[{text: ('address.email.required' | translate), name: 'required'},
                    {text: ('address.email.invalid' | translate), name: 'email'}]"
          ></bdo-single-line-input>
        </div>
        <div class="bdo-form-item-container">
          <bdo-single-line-input
            #mailRepeatInput
            [inputName]="'mailRepeat'"
            [inputValue]="mailRepeat"
            [inputType]="'email'"
            [placeholder]="'address.email.second' | translate"
            [labelText]="'address.email.second' | translate"
            (inputValueChanged)="mailRepeat=$event; onFocus()"
            (inputFocused)="onFocus()"
            [required]="true"
            [forceValidate]="validateAll"
            [validationIconHidden]="validationIconHidden"
          [errors]="[{ text: ('register.email.secondRequired' | translate), name: 'required'},
                    {text: ('address.email.invalid' | translate), name: 'email'},
                    {condition: registerForm.value?.mail!==registerForm.value?.mailRepeat, text: ('register.email.mustMatch' | translate), name: 'same'}]"
          ></bdo-single-line-input>
        </div>
        <div class="bdo-form-item-container">
          <bdo-single-line-input
            #usernameInput
            [inputName]="'usernameNew'"
            [inputValue]="usernameNew"
            [inputType]="'text'"
            [placeholder]="'register.username.title' | translate"
            [labelText]="'register.username.title' | translate"
            (inputValueChanged)="usernameNew=$event; onFocus(); checkingUsername = true;"
            (inputValueChangedDelayed)="checkUsernameAvailable(registerForm.value?.usernameNew)"
            [inputValueChangedDelayedTime]="1000"
            (inputFocused)="onFocus()"
            [required]="true"
            [minLength]="5"
            [forceValidate]="validateAll"
            [validationIconHidden]="validationIconHidden || checkingUsername"
          [errors]="[{ text: 'register.username.required' | translate, name: 'required'},
                    { condition: checkUsername(registerForm.value?.usernameNew), text: 'register.error.invalidCharacters' | translate, name: 'allowedChars'},
                    { condition: !usernameAvailable, text: 'register.error.usernameAlreadyExists' | translate, name: 'nameAvailable'},
                    { condition: checkingUsername, text: ('register.username.beingChecked' | translate), name: 'checkPending'},
                    { condition: registerForm.value?.usernameNew?.length>0 && registerForm.value?.usernameNew?.length<5, text: 'general.validator.minLength' | translate: { numberOfCharacters: 5 }, name: 'minLength'}]"
        ></bdo-single-line-input>
        <span class="bdo-form__helptext"> {{ 'register.username.rules' | translate }}</span>
      </div>

      <div class="bdo-form-item-container">
          <bdo-single-line-input
          #passwordNewInput
          [inputName]="'passwordNew'"
            [inputValue]="passwordNew"
            [inputType]="'password'"
            [placeholder]="'register.password.title' | translate"
            [labelText]="'register.password.title' | translate"
            (inputValueChanged)="passwordNew=$event; onFocus()"
            (inputFocused)="onFocus()"
            [required]="true"
            [forceValidate]="validateAll"
            [validationIconHidden]="validationIconHidden"
            [errors]="[{ condition: !isValidPassword , text: 'register.error.passwordPolicy' | translate, name: 'passwordPolicy'},
                       { condition: isCompromisedPassword, text: 'register.error.compromisedPassword' | translate, name: 'compromised'}]"
          ></bdo-single-line-input>
          <bdo-password-strength [passwordNew]="registerForm.value?.passwordNew"></bdo-password-strength>
        </div>
        <div class="bdo-form-item-container">
          <bdo-single-line-input
            #passwordRepeatInput
            [inputName]="'passwordRepeat'"
            [inputValue]="passwordRepeat"
            [inputType]="'password'"
            [placeholder]="'register.password.repeat' | translate"
            [labelText]="'register.password.repeat' | translate"
            (inputValueChanged)="passwordRepeat=$event; onFocus()"
            (inputFocused)="onFocus()"
            [required]="true"
            [forceValidate]="validateAll"
            [validationIconHidden]="validationIconHidden"
          [errors]="[{ text: ('register.password.reenterRequired' | translate), name: 'required'},
                    {condition: registerForm.value?.passwordNew!==registerForm.value?.passwordRepeat, text: ('register.error.passwordsDontMatch' | translate), name: 'same'}]"
          ></bdo-single-line-input>
        </div>
        <div class="bdo-form-item-container">
          <bdo-checkbox
            data-qa="tos-checkbox"
            [checked]="tosAccepted"
            [required]="tosTouched"
            [errorText]="'register.terms.confirmTosRequired' | translate"
            (change)="onTosClicked();">
            <span>
              {{ 'register.terms.termsAndConditions1' | translate }}
              <a class="bdo-link--inline"
                [routerLink]="['/nutzungsbedingungen']"
                (click)="trackIt()"
                target="_blank">
              {{ 'register.terms.termsAndConditions2' | translate }}</a>
              {{ 'register.terms.termsAndConditions3' | translate }}
            </span>
          </bdo-checkbox>
        </div>
        @if (competitionHelperService.isActive()) {
          <div class="bdo-form-item-container">
            <bdo-checkbox
              [checked]="competitionChecked"
              (change)="onCompetitionChanged()">
              <span [innerHTML]="'register.account.competition' | translate: { hrefCompetition: reBaseData.hrefCompetition }"></span>
            </bdo-checkbox>
          </div>
        }
        <div class="bdo-space--bottom">
          <button class="bdo-button-primary bdo-button--text re-mb-30" type="submit">
            {{ 'register.submit' | translate }}
          </button>
          <a class="bdo-nolink" [routerLink]="['/login']" data-qa="cancel">
            <div class="bold"> {{ 'general.action.cancel' | translate }}</div>
          </a>
        </div>
      </fieldset>
    }


  </form>
</div>

<!-- FAQs -->
<bdo-faqs
  [keyName]="'register.faqs'"
  [params]="{ contactLink: reBaseData.hrefContact }"
></bdo-faqs>


<bdo-simple-text-popup [isVisible]="registeringDone" (closePopupEvent)="closeMessage()">
  <bdo-register-success (closeEmitter)="closeMessage()"></bdo-register-success>
</bdo-simple-text-popup>
